import React from 'react'
import {Link} from 'react-router-dom'

import img_bounties from '../assets/bountyhub-bounties.png';
import Bounties from './Bounties.js'


export default class extends React.Component {

  render() {
    return (
      <div>

        <div className="full header image-header" style={{marginBottom:"30px"}}>
          <div className="wrap">
            <h1>Thank you for registering!</h1>
            <h3>BountyHub.NET is currently in development, but registering makes sure you get updated when the platform is fully available!</h3>
            <h2>BountyHub.NET is first focusing on attracting Creators, to make it interesting for the Companies to make Bounties. Want to help this platform become a reality sooner? Refer the website to your Creator friends!</h2>
            <h3>Follow <a href="https://x.com/PolymediaNL" target="_blank" rel="noopener noreferrer" style={{color:"#ff9934"}}>Polymedia on Twitter</a> or <a href="https://www.threads.net/@bountyhub_" target="_blank" rel="noopener noreferrer" style={{color:"#ff9934"}}>@bountyhub_ on Threads</a>, there will be an announcement when the platform is ready.</h3>
          </div>
        </div>
        
        <Bounties />

        <div className="full big purple">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>How does it work?</h1><h2>Companies post information about the Promotion Opportunities for everyone to see, called a &quot;Bounty&quot;. The company has paid to post this Bounty, there is no cost for the Creator. You can let your interest be known and then be able to execute the Bounty.</h2>
              </div>
              <div className="col-2"><img src={img_bounties} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0 auto", maxHeight:"340px"}} /></div>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Core.js